<template>
    <div class="mb-auto">
        <div class="content" v-if="moduleMethodsLoaded">
            <draggable
                    v-model="structure"
                    class="v-tabs__container"
                    v-bind="{group:'moduleGroups'}"
                    @start="isDragging=true" @end="isDragging=false"
                    :move="checkMove"
                    :id="'module_group_id' + moduleGroupId"
            >
                <v-card-text class="pa-1 ma-0"
                             v-for="(module, indexStructure) in structure"
                             :key="+(moduleGroupId + '' + indexStructure)"
                >
                    <module-card
                            :model="module"
                            :index="indexStructure"
                            @editModel="editModel([moduleGroupId, indexStructure])"
                            @removeModel="removeModel([moduleGroupId, indexStructure])"
                    ></module-card>
                </v-card-text>
            </draggable>
            <dialog-confirmation ref="confirm"></dialog-confirmation>
            <module-form
                    :indexes="[editModuleGroupId, editStructureIndex]"
                    :dialog="dialogModuleForm"
                    @close="dialogModuleForm = false"
            ></module-form>
        </div>
    </div>
</template>

<script>

import ModuleCard from './ModuleCard'
import draggable from 'vuedraggable'
import DialogConfirmation from '../../dialogs/DialogConfirmation'
import ModuleForm from './ModuleForm'

export default {
    name: 'ModuleGroupList',
    props: ['moduleGroupId', 'moduleMethodsLoaded'],
    components: {
        draggable,
        ModuleCard,
        DialogConfirmation,
        ModuleForm
    },
    computed: {
        structure: {
            get () {
                let moduleGroup = this.$store.state.moduleGroups.moduleGroups.find(moduleGroup => moduleGroup.id === this.moduleGroupId)
                if (moduleGroup) { return moduleGroup.structure } else return []
            },
            set(value) {
                this.$store.commit('moduleGroups/setModuleGroupByDraggable', {
                    value,
                    key: this.moduleGroupId
                })
                this.saveModuleGroup()
            }
        }
    },
    data() {
        return {
            isDragging: false,
            dialogModuleForm: false,
            editModuleGroupId: null,
            editStructureIndex: null
        }
    },
    methods: {
        checkMove(event) {
            if (event.draggedContext.element === undefined) {
                return false
            }
        },
        async removeModel(indexes) {
            this.$refs.confirm.open('Удаление сообщения', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        let newStructure = this.structure.slice()
                        newStructure.splice(indexes[1], 1)
                        this.structure = newStructure
                        this.saveModuleGroup()
                    }
                })
        },
        saveModuleGroup() {
            let moduleGroup = this.$store.state.moduleGroups.moduleGroups.find(moduleGroup => moduleGroup.id === this.moduleGroupId)
            this.$store.dispatch('moduleGroups/saveModuleGroupWithoutMutation', moduleGroup)
        },
        editModel(indexes) {
            this.editModuleGroupId = indexes[0]
            this.editStructureIndex = indexes[1]
            this.dialogModuleForm = true
        }
    },
    watch: {
        dialogModuleAdd() {
            if (this.dialogModuleAdd === false) {
                this.moduleGroupIndex = null
            }
        }
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
